import {Action} from "redux-actions";
import Meta from "../_data/models/Meta";
import {clearFeedsAction, receiveFeedsAction, requestFeedsAction} from "./actions";
import Feed from "../_data/models/Feed";
import {combineReducers} from "redux";
import {Map} from "immutable";
import {plainToClass} from "class-transformer";
import {collectionToKeyValue} from "../_helpers/utils";
import commentsReducer from "../comment/reducers";

//reducers
export const feeds = combineReducers({
    items,
    meta,
    loading,
    comments:commentsReducer
});

export default feeds;

function items(state: Map<number, Feed> = Map<number, Feed>(), action: Action<FeedAction>) {
    switch (action.type) {
        case clearFeedsAction.toString():
            return Map<number, Feed>();
        case receiveFeedsAction.toString():
            return state.mergeDeep(collectionToKeyValue(plainToClass(Feed, action.payload.feeds)));
    }
    return state;
}

function meta(state: Meta = null, action: Action<FeedAction>) {
    switch (action.type) {
        case receiveFeedsAction.toString():
            return plainToClass(Meta, action.payload.meta);
    }
    return state;
}

function loading(state: boolean = false, action: Action<FeedAction>) {
    switch (action.type) {
        case requestFeedsAction.toString():
            return true;
        case receiveFeedsAction.toString():
            return false;
    }
    return state;
}


//interfaces
interface FeedAction {
    feeds: any;
    meta: Meta;
    feedId: number;
    like: boolean
}


// WEBPACK FOOTER //
// ./app/client/activityFeeds/reducers.ts